import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import PrivateRoute from "./privateRoutes";
const Login = lazy(() => import("../componant/login"));
const AboutUs = lazy(() => import("../componant/aboutUs"));
const ContactUs = lazy(() => import("../componant/contactUs"));
const Dashboard = lazy(() => import("../componant/dashboard"));
const PartnerShip = lazy(() => import("../componant/partnerShip"));
const BlogPost = lazy(() => import("../componant/blogPost"));
const BehindTheMap = lazy(() => import("../componant/behindTheMap"));
const SinglePost = lazy(() => import("../componant/singlePostBlog"));
const AdminPartnerShip = lazy(() =>
  import("../componant/Admin/adminPartnership")
);
const AdminBlog = lazy(() => import("../componant/Admin/blog"));
const AddPodcast = lazy(() => import("../componant/Admin/addPodcast"));
const AddPerSonalities = lazy(() => import("../componant/Admin/personalities"));
const SubcribersList = lazy(() => import("../componant/Admin/allSubcriber"));
const PodcastSinglePost = lazy(() => import("../componant/podcastSinglePost"));
const AllPodcast = lazy(() => import("../componant/allPodcast"));
const HeaderBanner = lazy(() => import("../componant/Admin/banner"));
const AllAfricanPersonalities = lazy(() =>
  import("../componant/allAfricanPersonalities")
);
const AfricanNews = lazy(() => import("../componant/africanNews"));
const InsertDataForm = lazy(() => import("../componant/Admin/insertDataForm"));
const Content = lazy(() => import("../componant/Admin/content"));
const UploadFounderImage = lazy(() =>
  import("../componant/Admin/uploadFounderImage")
);
const AllContact = lazy(() => import("../componant/Admin/contactUsPage"));

// import AboutUsAdmin from "../componant/Admin/aboutUs";

const AppRoutes = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="*" element={<Dashboard />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/login" element={<Login />} />
        <Route path="/partnership" element={<PartnerShip />} />
        <Route path="/InsertData" element={<InsertDataForm />} />

        <Route
          path="/africastartups"
          element={<BlogPost type="Africa Startups" />}
        />
        <Route
          path="/africacompanies"
          element={<BlogPost type="Africa Companies" />}
        />
        <Route path="/countries" element={<BlogPost type="Countries" />} />

        <Route path="/africanpersonalities" element={<BehindTheMap />} />
        <Route
          path="/allAfricanPersonalities"
          element={<AllAfricanPersonalities />}
        ></Route>
        <Route path="/singlepost" element={<SinglePost />} />
        <Route
          path="/adminPartnerShip"
          element={<PrivateRoute element={AdminPartnerShip} />}
        />
        <Route
          path="/adminBlog"
          element={<PrivateRoute element={AdminBlog} />}
        />
        <Route
          path="/addPodcast"
          element={<PrivateRoute element={AddPodcast} />}
        />
        <Route
          path="/addPerSonalities"
          element={<PrivateRoute element={AddPerSonalities} />}
        />
        <Route
          path="/subcribersList"
          element={<PrivateRoute element={SubcribersList} />}
        />

        <Route path="/podcastsinglepost" element={<PodcastSinglePost />} />
        <Route path="/allpodcast" element={<AllPodcast />} />

        <Route path="/headerBanner"   element={<PrivateRoute element={HeaderBanner} />} ></Route>

        <Route path="/africanNews" element={<AfricanNews />}></Route>
        <Route
          path="/content"
          element={<PrivateRoute element={Content} />}
        ></Route>
        <Route
          path="/uploadFounderImage"
          element={<PrivateRoute element={UploadFounderImage} />}
        ></Route>
        <Route path="/allContact" element={<PrivateRoute element={AllContact} />} ></Route>

        {/* <Route path='/AboutUsAdmin' element={<AboutUsAdmin />}></Route> */}
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
